import Case from './CasePage';

export default Case;
